import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CustomTypography from '../../custom-material/typography/Typography'

const styles = theme => ({
  empty: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16
  }
})

class EmptyStateComponent extends React.PureComponent {
  render () {
    const { classes, title } = this.props

    return (
      <div className={classes.empty}>
        <CustomTypography style={{fontSize: 15}} variant='body1'>
          {title}
        </CustomTypography>
      </div>
    )
  }
}

EmptyStateComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired
}

export default withStyles(styles)(EmptyStateComponent)
